import { OidcRootState, selectOidc } from "@org-avp/avp-avengers-ui-shared-store";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

type PrepareHeaders = NonNullable<Parameters<typeof fetchBaseQuery>[0]>["prepareHeaders"];
export const prepareHeaders: PrepareHeaders = (headers, { getState }) => {
  const oidcState = selectOidc(getState() as OidcRootState);
  if (oidcState.userData?.accessToken == null) {
    console.warn("No auth token found!");
    return headers;
  }

  headers.append("Authorization", `Bearer ${oidcState.userData.accessToken}`);
  return headers;
};
